var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1694 4.22388H18.9566C19.5499 4.22388 20.0353 4.7093 20.0353 5.30259V7.46003C20.0353 8.05332 19.5499 8.53875 18.9566 8.53875H8.1694C7.5761 8.53875 7.09068 8.05332 7.09068 7.46003V5.30259C7.09068 4.7093 7.5761 4.22388 8.1694 4.22388ZM6.00837 9.61908H21.1104C22.9011 9.61908 24.3466 11.0646 24.3466 12.8552V17.1701C24.3466 18.3567 23.3757 19.3275 22.1891 19.3275H20.0317V21.485C20.0317 22.6716 19.0608 23.6424 17.8743 23.6424H9.24452C8.05793 23.6424 7.08709 22.6716 7.08709 21.485V19.3275H4.92965C3.74306 19.3275 2.77222 18.3567 2.77222 17.1701V12.8552C2.77222 11.0646 4.2177 9.61908 6.00837 9.61908ZM10.3291 21.484H16.8014C17.3947 21.484 17.8801 20.9986 17.8801 20.4053V16.0904H9.2504V20.4053C9.2504 20.9986 9.73582 21.484 10.3291 21.484ZM21.112 13.9323C20.5187 13.9323 20.0333 13.4469 20.0333 12.8536C20.0333 12.2603 20.5187 11.7749 21.112 11.7749C21.7053 11.7749 22.1908 12.2603 22.1908 12.8536C22.1908 13.4469 21.7053 13.9323 21.112 13.9323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.1dc76ca29f9da00a63191730899e254a.svg";
export { ForwardRef as ReactComponent };